import * as React from 'react';
import { OrdersPageContainer } from './containers';

const OrdersPageRoute: React.FC = () => <OrdersPageContainer />;

export default OrdersPageRoute;
